<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.InquiryOverview.pageName')" />
        <div class="box-round display-height">
            <div class="box-content px-0">
                <div class="px-7">
                  <v-text-field
                    class="custom-input-search search"
                    hide-details="auto"
                    outlined
                    v-model="textSearch"
                    :placeholder="$vuetify.lang.t('$vuetify.InquiryOverview.search.placeholder')"
                    @input="inputSearch()"
                  ></v-text-field>
                </div>
                <div class="mt-5 d-flex flex-nowrap header-item text-sm">
                    <v-col cols="7" class="px-0 py-2 pl-7 line-liff-detail">
                      {{$vuetify.lang.t('$vuetify.InquiryOverview.header.full')}}
                    </v-col>
                    <v-col cols="3" class="px-0 py-2 pl-4 line-liff-detail">
                      {{$vuetify.lang.t('$vuetify.InquiryOverview.header.sub')}}
                    </v-col>
                    <v-col cols="2" class="px-0 py-2"></v-col>
                </div>
                <div class="pb-5">
                  <div class="d-flex flex-nowrap list-item"
                      v-for="(v,i) of list"
                      :key="i"
                      @click="clickGotoDetail(v.id, v.shortName)">
                      <v-col cols="7" class="px-0 py-2 font-weight-bold pl-7 text-truncate">
                        {{ v.name }}
                      </v-col>
                      <v-col cols="3" class="px-0 py-2 font-weight-bold pl-4">
                        {{ v.shortName }}
                      </v-col>
                      <v-col cols="2" class="px-0 py-2 text-center">
                        <v-icon>mdi mdi-chevron-right</v-icon>
                      </v-col>
                  </div>
                </div>
            </div>
            <div class="box-footer">
                <div class="bottom-paging">
                    <v-pagination
                      v-model="page"
                      class="my-0 text-sm"
                      :length="numPages"
                      @input="search()"
                    ></v-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TopBar from '@/components/Liff/Components/header/TopBar.vue'
export default {
    name: 'InquiryOverview',
    components: {
        TopBar
    },
    data: function () {
        return {
            delayTimer: null,
            textSearch: null,
            page: 1,
            totalShow: 10,
            numPages: 1,
            list: []
        }
    },
    created: function () {
    },
    mounted: function () {
        this.search()
    },
    methods: {
        inputSearch: async function () {
            clearTimeout(this.delayTimer)
            this.delayTimer = setTimeout(this.search, 500)
        },
        search: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                let url = `inquiries/line/overview?page=${this.page}`
                if (this.textSearch) url += `&search=${this.textSearch}`
                const res = await this.axios.get(url)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                    this.numPages = res.data.numPages
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        clickGotoDetail: function (id) {
            this.$router.push('/liff/inquiry/bureau?id=' + id)
        }
    }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/color.scss';
  .header-item {
      color: $base-grey2;
      background: #d9e4ed;
      font-size: 14px;
  }
  .list-item {
    color: $base-grey3;
    border-bottom: 1px solid #e0e0e0;
  }
  ::v-deep .v-pagination__item{
    font-family: LexendDeca;
    font-size:12px;
  }
</style>
